import firebase from 'firebase/app'

import 'firebase/firestore'

var firebaseConfig = {
    name: "valorantaccounts.net",
    apiKey: "AIzaSyBQm2gvCzCrYg0OA3M25m4k8wZjReEhxVE",
    authDomain: "valorantaccounts.firebaseapp.com",
    databaseURL: "https://valorantaccounts.firebaseio.com",
    projectId: "valorantaccounts",
    storageBucket: "valorantaccounts.appspot.com",
    messagingSenderId: "627376061637",
    appId: "1:627376061637:web:e45d7f24c5069bfc1084ac"
  };
  // Initialize Firebase
const firebaseapp = firebase.initializeApp(firebaseConfig);

export default firebaseapp.firestore()


// WEBPACK FOOTER //
// ./src/db/index.js